var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "do_disturb_alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4372 5.60363L14.8357 5.20512L14.3926 4.85692C13.1391 3.87206 11.614 3.33341 10.0003 3.33341C6.05752 3.33341 2.83366 6.55727 2.83366 10.5001C2.83366 12.1138 3.37231 13.6389 4.35717 14.8923L4.70536 15.3355L5.10388 14.937L14.4372 5.60363ZM5.56344 15.3965L5.16492 15.795L5.60808 16.1432C6.86154 17.1281 8.38665 17.6667 10.0003 17.6667C13.9431 17.6667 17.167 14.4429 17.167 10.5001C17.167 8.8864 16.6283 7.36129 15.6435 6.10784L15.2953 5.66468L14.8968 6.06319L5.56344 15.3965ZM2.16699 10.5001C2.16699 6.19289 5.69313 2.66675 10.0003 2.66675C14.3075 2.66675 17.8337 6.19289 17.8337 10.5001C17.8337 14.8073 14.3075 18.3334 10.0003 18.3334C5.69313 18.3334 2.16699 14.8073 2.16699 10.5001Z",
    stroke: "#E03352"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.7bf8b022496318519b0c66bd6380053f.svg";
export { ForwardRef as ReactComponent };